<app-filters-side-panel [mode]="'channels'" [featurePageLocalStorageKey]="FeaturePageLocalStorageKeyEnum.SEARCH_PAGE">
  <mat-tab-group mat-align-tabs="start" [selectedIndex]="1">
    <mat-tab disabled [label]="'search/message-type/customer' | translate"> </mat-tab>
    <mat-tab [label]="'search/message-type/message-content' | translate"> </mat-tab>
  </mat-tab-group>

  <div class="global-search" [class.highlight]="searchBarPopoverDisplayed">
    <div cdkOverlayOrigin #searchBarTrigger>
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="text"
      [formControl]="$any(searchService.form.get('messageContent.containingText'))"
      [placeholder]="'search/message-type/message-content/search-placeholder' | translate" />
    <mat-icon *ngIf="searchService.form.value.messageContent.containingText" (click)="clearSearch()">close</mat-icon>
    <div cdkOverlayOrigin #advancedSearchTrigger>
      <mat-icon [class.highlight]="advancedSearchPopoverDisplayed" (click)="modifyFilters()">filter_list</mat-icon>
    </div>
  </div>

  <app-pseudo-mass-actions></app-pseudo-mass-actions>

  <ng-container *ngIf="searchService.missingSearchCriteria; else searchResults">
    <app-nothing-to-search></app-nothing-to-search>
  </ng-container>

  <ng-template #searchResults>
    <ng-content></ng-content>
  </ng-template>
</app-filters-side-panel>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="searchBarTrigger"
  [cdkConnectedOverlayOpen]="searchBarPopoverDisplayed"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayOffsetX]="0"
  [cdkConnectedOverlayOffsetY]="0">
  <div class="feature-tour-step-container">
    <app-step-popover
      [titleKey]="'search/feature-tour/search-bar/title'"
      [descriptionKey]="'search/feature-tour/search-bar/description'"
      [nextKey]="'search/feature-tour/next'"
      [previousKey]="'search/feature-tour/previous'"
      (closeStep)="searchBarPopoverDisplayed = false"
      (next)="featureTourService.setFeatureStep(FeatureTourStepEnum.ADVANCED_SEARCH)"
      (previous)="featureTourService.setFeatureStep(FeatureTourStepEnum.START)"></app-step-popover>
  </div>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="advancedSearchTrigger"
  [cdkConnectedOverlayOpen]="advancedSearchPopoverDisplayed"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayOffsetX]="0"
  [cdkConnectedOverlayOffsetY]="0">
  <div class="feature-tour-step-container">
    <app-step-popover
      [titleKey]="'search/feature-tour/advanced-search/title'"
      [descriptionKey]="'search/feature-tour/advanced-search/description'"
      [nextKey]="'search/feature-tour/next'"
      [previousKey]="'search/feature-tour/previous'"
      (closeStep)="advancedSearchPopoverDisplayed = false"
      (next)="featureTourService.setFeatureStep(FeatureTourStepEnum.MASS_ACTIONS)"
      (previous)="featureTourService.setFeatureStep(FeatureTourStepEnum.SEARCH_BAR)"></app-step-popover>
  </div>
</ng-template>

<!-- Needed to allow to highlight elements -->
<div
  *ngIf="searchBarPopoverDisplayed || advancedSearchPopoverDisplayed || massActionsPopoverDisplayed"
  class="backdrop"></div>

<ng-template #filtersFormTemplateRef>
  <form [formGroup]="searchService.form">
    <section formGroupName="messageAttributes">
      <h1 translate="search/advanced-search/messages-attributes/title"></h1>
      <div class="receipt-date-range">
        <app-select
          [control]="searchService.form.get('messageAttributes.receiptDate')"
          [items]="searchService.dateRanges"
          labelKey="search/advanced-search/messages-attributes/receipt-date"
          appearance="outline"></app-select>
        <mat-icon>event</mat-icon>
      </div>
      <app-select
        [control]="searchService.form.get('messageAttributes.accounts')"
        [items]="searchService.sites"
        [multiple]="true"
        [optionTemplateName]="'site-icon'"
        appearance="outline"
        labelKey="search/advanced-search/messages-attributes/accounts">
      </app-select>

      <!-- <app-select
        [multiple]="true"
        [control]="searchService.form .get('messageAttributes.teams')"
        [items]="teams"
        labelKey="search/advanced-search/messages-attributes/teams"
        appearance="outline"></app-select> -->
      <app-select
        [multiple]="true"
        [control]="searchService.form.get('messageAttributes.statuses')"
        [items]="searchService.statuses"
        labelKey="search/advanced-search/messages-attributes/statuses"
        appearance="outline"></app-select>
      <!-- <app-select
        [multiple]="true"
        [control]="searchService.form .get('messageAttributes.languages')"
        [items]="languages"
        labelKey="search/advanced-search/messages-attributes/languages"
        appearance="outline"></app-select> -->
    </section>
    <section formGroupName="messageContent">
      <h1 translate="search/advanced-search/messages-content/title"></h1>
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="search/advanced-search/messages-content/containing-text"></mat-label>
        <input matInput formControlName="containingText" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="search/advanced-search/messages-content/not-containing-text"></mat-label>
        <input matInput formControlName="notContainingText" />
      </mat-form-field>
    </section>
    <section formGroupName="actions">
      <h1 translate="search/advanced-search/message-actions/title"></h1>
      <div class="action-date-range">
        <app-select
          [control]="searchService.form.get('actions.date')"
          [items]="searchService.actionDateRanges"
          labelKey="search/advanced-search/message-actions/action-date"
          appearance="outline"></app-select>
        <mat-icon>event</mat-icon>
      </div>
      <app-select
        [multiple]="true"
        [control]="searchService.form.get('actions.types')"
        [items]="searchService.actionTypes"
        labelKey="search/advanced-search/message-actions/action-types"
        appearance="outline"></app-select>
      <app-select
        [multiple]="true"
        [control]="searchService.form.get('actions.processedBy')"
        [items]="searchService.advisors"
        labelKey="search/advanced-search/message-actions/advisors-who-processed"
        appearance="outline"></app-select>
      <mat-checkbox formControlName="hideMessagesProcessedOnlyByBots">
        <span translate="search/advanced-search/message-actions/hide-messages-processed-only-by-bot"></span>
      </mat-checkbox>
    </section>
  </form>
</ng-template>
